export const environment = {
  production: true,
  routes: {
    admin: '/admin',
    vpogled: '/vpogled',
  } as Record<string, unknown>,
  keycloakConfig: {
    url: 'https://ekmetijstvo.gov.si/auth',
    realm: 'arsktrp',
    clientId: 'vpo2327',
  },
};
